(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './Buttons'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Buttons'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Buttons);
    global.index = mod.exports;
  }
})(this, function (exports, _Buttons) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.keys(_Buttons).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _Buttons[key];
      }
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/index.js
// module id = 529
// module chunks = 1